import styled from '@emotion/styled';
import { Box } from '@mui/material';

const DashboardContainer = styled(Box)`
    background: 'linear-gradient(180deg, #FFF 50%, rgba(206, 189, 230, 0.15) 100%)';
`;

export { DashboardContainer };
